import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Row,
} from "react-bootstrap";
import sslSecurityImage from "../../Assets/images/ssl_security.png";
import Table from "react-bootstrap/Table";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { apiBaseURL } from "../../Common/ApiHelper";
import LoginModal from "../../Common/LoginModal";
import Payment from "./Payment";
import { BsXLg } from "react-icons/bs";

const Checkout = () => {
  const [emailStatus, setEmailStatus] = useState(false);
  const [logedIn, setLogedIn] = useState(false);
  const [loginDisplay, setLoginDisplay] = useState(false);
  const [discount, setDiscount] = useState(null);
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponCode, setCouponCode] = useState(null);
  const [Status, setStatus] = useState(false);
  const [allCoupons, setAllCoupons] = useState([]);
  const [formattedNumber, setFormattedNumber] = useState("");
  const [appliedCouponResponse, setAppliedCouponResponse] = useState([]);
  const [payableAmount, setPayableAmount] = useState(0);
  const [userDetails, setUserDetails] = useState({});
  const [couponCheckApiStatus, setCouponCheckApiStatus] = useState(0);
  const [checkoutValuesPayload, setCheckoutValuesPayload] = useState();
  const [price, setTotalPrice] = useState();
  const navigate = useNavigate();
  const [userCart, setUserCart] = useState(
    JSON.parse(localStorage.getItem("Usercart"))
  );
  const [cartItems, setCartItems] = useState(
    JSON.parse(localStorage.getItem("cartItems"))
  );

  const schema = yup.object().shape({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    confirmEmail: yup
      .string()
      .oneOf([yup.ref("email"), null], "Emails must match")
      .email("Invalid email address")
      .required("Confirm Email is required"),
    password: yup
      .string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),
    mobile: yup
      .string()
      .matches(/^\d+$/)
      .min(10, "Mobile number must have at least 10 digits")
      .required(),
    streetAddress: yup.mixed().required(),
    city: yup.mixed().required(),
    state: yup.mixed().required(),
    country: yup.mixed().required(),
    terms: yup.bool().required().oneOf([true], "Terms must be accepted"),
  });
  const initialFormikValues = () => {
    setCheckoutValuesPayload({
      ...checkoutValuesPayload,
      email: userDetails?.email,
      firstName: userDetails?.firstName,
      lastName: userDetails?.lastName,
      streetAddress: userDetails?.streetAddress,
      mobile: userDetails?.mobile?.toString(),
      companyName: userDetails?.companyName,
      state: userDetails?.state,
      city: userDetails?.city,
      country: userDetails?.country,
    });
  };
  useEffect(() => {
    if (checkoutValuesPayload?.mobile) {
      setFormattedNumber(
        checkoutValuesPayload?.mobile
          .toString()
          .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
      );
    }
  }, [checkoutValuesPayload]);
  const handleFormikChanges = (e) => {
    const debounceDelay = 500;
    if (localStorage.getItem("token")) {
      if (e.target.name === "mobile") {
        var digits = e.target?.value?.replace(/\D/g, "");
        var mobileValues = digits.replace(
          /(\d{3})(\d{3})(\d{4})/,
          "($1) $2-$3"
        );
        setFormattedNumber(mobileValues);
      }
      setCheckoutValuesPayload({
        ...checkoutValuesPayload,
        // email: userDetails?.email,
        // firstName: userDetails?.firstName,
        // lastName: userDetails?.lastName,
        // streetAddress: userDetails?.streetAddress,
        // companyName: userDetails?.companyName,
        // state: userDetails?.state,
        // city: userDetails?.city,
        // country: userDetails?.country,
        [e.target.name]: e.target.value,
        mobile:
          digits || digits === "" ? digits : checkoutValuesPayload?.mobile,
      });
    }
    if (!localStorage.getItem("token")) {
      if (e.target.name === "mobile") {
        var digit = e.target?.value?.replace(/\D/g, "");
        var mobileValue = digit?.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        setFormattedNumber(mobileValue);
      }
      setCheckoutValuesPayload({
        ...checkoutValuesPayload,
        [e.target.name]: e.target.value,
        mobile: digit || digit === "" ? digit : checkoutValuesPayload?.mobile,
      });
    }

    if (!localStorage.getItem("userData") && e.target.name === "email") {
      const debouncedFunction = setTimeout(() => {
        const fetchData = async () => {
          try {
            const response = await axios({
              method: "post",

              url: `${apiBaseURL}user/isEmailExist`,
              data: { email: e.target.value },
              headers: {
                authorization: `Bearer ${localStorage.getItem("user")}`,
              },
            });
            if (response?.data.statusCode === 200) {
              setEmailStatus(true);
              if (!localStorage.getItem("userData")) setLoginDisplay(true);
              else setLoginDisplay(false);
            }
          } catch (e) {
            console.log("e: ", e.message);
            setEmailStatus(false);
          }
        };
        fetchData();
        if (localStorage.getItem("token") === null) {
          setStatus(false);
        }
      }, debounceDelay);
      return () => clearTimeout(debouncedFunction);
    } else {
    }
  };
  const handleCodeChange = (event) => {
    if (localStorage.getItem("token") === null) {
      setStatus(true);
    }
  };

  const applyCouponApi = async () => {
    try {
      const response = await axios({
        method: "post",
        url: `${apiBaseURL}user/addAppliedCoupon`,
        data: { code: couponCode },
      });
      if (response?.data.statusCode === 200) {
        if (localStorage.getItem("token")) {
          const result = await couponCheckApi();
          if (result === 200) {
            setCouponLoading(false);
            setAppliedCouponResponse(response.data.data);
            setDiscount(true);
            setPayableAmount(
              price - price * (response.data.data.percentage / 100)
            );
            toast.success("Coupon Applied", {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
          }
        } else {
          setCouponLoading(false);
          setAppliedCouponResponse(response.data.data);
          setDiscount(true);
          setPayableAmount(
            price - price * (response.data.data.percentage / 100)
          );
          toast.success("Coupon Applied", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        }
      }
    } catch (e) {
      setCouponLoading(false);
      setPayableAmount(price);
      setDiscount(false);
      toast.error(e.response.data.message, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const couponCheckApi = async () => {
    try {
      const userData = await JSON.parse(localStorage.getItem("userData"));
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/isCouponRedeemed?email=${userData.email}&&couponId=${couponCode}`,
      });
      if (response?.data.statusCode === 200) {
        setCouponCheckApiStatus(response?.data?.statusCode);
        return response?.data?.statusCode;
      }
    } catch (e) {
      setCouponLoading(false);
      setPayableAmount(price + price * 0.09);
      setDiscount(false);
      toast.error(e.response.data.message, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const handleCoupon = async (e) => {
    e.preventDefault();
    setCouponLoading(true);
    if (couponCode) {
      applyCouponApi();
    } else {
      setCouponLoading(false);
      toast.error("Please enter code", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const removeCoupon = () => {
    setCouponCode(null);
    setPayableAmount(price);
    setDiscount(false);
  };
  const handleRemove = (e) => {
    removeCoupon();
    let updatedArray = cartItems.filter((item) => item._id !== e._id);
    let addedArr = updatedArray.map((items) => items._id);
    localStorage.setItem("addedProducts", JSON.stringify(addedArr));
    localStorage.setItem("cartItems", JSON.stringify(updatedArray));
    localStorage.setItem(
      "Usercart",
      JSON.stringify({ cartData: updatedArray, totalPrice: price })
    );
    setCartItems(updatedArray);
    navigate("/checkout");
  };
  const handleAllCoupons = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getAllCoupon`,
      });
      if (response?.data.statusCode === 200) {
        setAllCoupons(response.data.data);
      }
    } catch (e) {
      console.log("e: handleAllCoupons", e.message);
    }
  };

  useEffect(() => {
    setPayableAmount(price);
    handleAllCoupons();
  }, [userCart, cartItems]);

  useEffect(() => {
    setUserDetails(JSON.parse(localStorage.getItem("userData")));
  }, [Status]);

  useEffect(() => {
    const calPrice = cartItems
      .map(
        (item) =>
          item.salePrice * item.quantity + item.salePrice * item.quantity * 0.09
      )
      .reduce((sum, num) => {
        return sum + num;
      }, 0);
    setTotalPrice(calPrice);
    setPayableAmount(calPrice);
  }, [userCart, cartItems]);

  useEffect(() => {
    if (couponCode) {
      applyCouponApi();
    }
  }, [userDetails]);

  useEffect(() => {
    if (!userCart?.cartData) navigate("/");
    if (cartItems.length === 0) navigate("/");
  }, [userCart?.cartData, cartItems]);
  useEffect(() => {
    if (userDetails?.country) {
      document.getElementById("country").value = userDetails?.country;
    }
  }, [userDetails]);
  useEffect(() => {
    initialFormikValues();
  }, [userDetails]);
  return (
    <>
      <ToastContainer />
      <div className="main pt-4 pb-5">
        <Container>
          <div className="product_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </Breadcrumb.Item>
              {cartItems.map((items) => {
                return (
                  <Breadcrumb.Item>
                    <small
                      className="BreadCrumbs_style"
                      onClick={() =>
                        navigate(`/product/${items.name.replace(/\s+/g, "")}`)
                      }
                    >
                      {items.name}
                    </small>
                  </Breadcrumb.Item>
                );
              })}
              <Breadcrumb.Item active>Checkout</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className="checkout_order_table mb-4 box_shadow">
            <Table responsive className="checkout_table_bigScreen">
              <tr className="check_table_header blue_bg">
                <th>Your Order</th>
                <th className="table_td_text_center">Qty</th>
                <th className="table_td_text_center">Price</th>
                <th className="table_td_text_center">Taxes</th>
                <th className="table_td_text_center">Subtotal</th>
                <th className="table_td_text_center px-0"></th>
              </tr>
              {cartItems.map((e, i) => {
                return (
                  <>
                    <tr className="check_table_content pt-4 white_bg">
                      <td>{e?.name} 32/64 Retail - Download & License Key </td>
                      <td className="table_td_text_center">{e?.quantity}</td>
                      <td className="table_td_text_center">
                        {e?.salePrice} USD
                      </td>
                      <td className="table_td_text_center">
                        {(e?.quantity * e?.salePrice * 0.09).toFixed(2)} USD
                      </td>
                      <td className="table_td_text_center gap-3">
                        {(
                          e?.quantity * e?.salePrice +
                          e?.quantity * e?.salePrice * 0.09
                        ).toFixed(2)}{" "}
                        USD
                      </td>
                      <td className="px-2">
                        <BsXLg
                          className="Header_Text Center_Cart_btn cursor_pointer p-0"
                          onClick={() => handleRemove(e)}
                        />
                      </td>
                    </tr>
                  </>
                );
              })}
              {discount ? (
                <>
                  <tr className="check_table_content pt-4 white_bg">
                    <td colSpan={4} style={{ textAlign: "right" }}>
                      Applied Coupon: {appliedCouponResponse?.code} (
                      {appliedCouponResponse?.percentage}%)
                    </td>
                    <td className="pt-4">
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <strong>
                          <span>{payableAmount.toFixed(2)} &nbsp;</span>
                          <strike>{price.toFixed(2)}</strike>
                          &nbsp;
                        </strong>
                      </span>
                    </td>
                    <td className="px-2">
                      <BsXLg
                        className="remove_coupon_btn Center_Cart_btn cursor_pointer p-0"
                        onClick={removeCoupon}
                      />
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
            </Table>
            <Table className="checkout_table_smallScreen">
              <tr className="check_table_header blue_bg">
                <th>Your Order</th>
                <th className="table_td_text_center">Details</th>
                <th className="table_td_text_center"></th>
              </tr>
              {cartItems.map((e, i) => {
                return (
                  <>
                    <tr className="check_table_content pt-4 white_bg">
                      <td style={{ width: "50%" }}>
                        {e?.name} 32/64 Retail - Download & License Key (
                        {e?.quantity})
                      </td>
                      <td className="table_td_text_center gap-3">
                        ({e?.salePrice} USD Price)
                        <br />({(e?.quantity * e?.salePrice * 0.09).toFixed(
                          2
                        )}{" "}
                        USD Tax)
                      </td>
                      <td>
                        <BsXLg
                          className="Header_Text Center_Cart_btn cursor_pointer p-0 responsive_close_btn"
                          onClick={() => handleRemove(e)}
                        />
                      </td>
                    </tr>
                    <tr className="check_table_content pt-4 white_bg">
                      <td style={{ width: "50%" }}>SubTotal:</td>
                      <td className="table_td_text_center gap-3">
                        {(
                          e?.quantity * e?.salePrice +
                          e?.quantity * e?.salePrice * 0.09
                        ).toFixed(2)}{" "}
                        USD
                      </td>
                      <td></td>
                    </tr>
                    <hr className="m-0" />
                  </>
                );
              })}
              {discount ? (
                <>
                  <tr className="check_table_content pt-4 white_bg">
                    <td colSpan={4} style={{ width: "50%" }}>
                      Applied Coupon: {appliedCouponResponse?.code} (
                      {appliedCouponResponse?.percentage}%)
                    </td>
                    <td className="pt-4" style={{ width: "50%" }}>
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <strong>
                          <span>{payableAmount.toFixed(2)} &nbsp;</span>
                          <strike>{price.toFixed(2)}</strike>
                          &nbsp;
                        </strong>
                      </span>
                    </td>
                    <td className="px-2">
                      <BsXLg
                        className="remove_coupon_btn Center_Cart_btn cursor_pointer p-0"
                        onClick={removeCoupon}
                      />
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
            </Table>
            <div className="white_bg checkout_table_info d-flex white_bg">
              <div className="promocode mt-0 px-0">
                <div>
                  <p className="mb-0">Enter Promo Code: </p>
                  <form className="promocode_form">
                    <input
                      type="text"
                      placeholder="Welcome10"
                      value={couponCode || ""}
                      onChange={(e) => setCouponCode(e.target.value)}
                    />
                    <button onClick={(e) => handleCoupon(e)}>
                      {couponLoading ? (
                        <span
                          class="spinner-border spinner-border-sm me-1"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        ""
                      )}
                      Enter Code
                    </button>
                  </form>
                </div>
                <div className="me-4">
                  <h6>
                    <b>Order Details:</b>
                  </h6>
                  <h6>
                    <b>${parseFloat(payableAmount).toFixed(2)} USD</b>
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div className="billing_info_wrapper mt-5">
            <Row>
              <Col className="checkout_form_wrapper" xxl="7" lg="7">
                <Formik
                  initialValues={userDetails}
                  validationSchema={schema}
                  onChange={handleFormikChanges}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    touched,
                    isValid,
                    errors,
                  }) => (
                    <>
                      <h2 className="blue_bg text-white mb-0">
                        Billing Information
                      </h2>
                      <div className="billing_information mb-4">
                        <Form
                          noValidate
                          onSubmit={handleSubmit}
                          onChange={handleFormikChanges}
                        >
                          <Form.Group className="">
                            <Row>
                              <Col>
                                <Form.Label className=" d-block">
                                  First Name*
                                </Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  id="firstName"
                                  name="firstName"
                                  value={checkoutValuesPayload?.firstName}
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  disabled={emailStatus}
                                  className="checkout_input"
                                  isValid={
                                    touched.firstName && !errors.firstName
                                  }
                                />
                                {errors.firstName &&
                                touched.firstName &&
                                !checkoutValuesPayload.firstName ? (
                                  <span style={{ color: "red" }}>
                                    First name is required.
                                  </span>
                                ) : null}
                              </Col>
                              <Col>
                                <Form.Label className="">Last Name*</Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  id="lastName"
                                  name="lastName"
                                  value={checkoutValuesPayload?.lastName}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className="checkout_input"
                                  disabled={emailStatus}
                                  isValid={touched.lastName && !errors.lastName}
                                />
                                {errors.lastName &&
                                touched.lastName &&
                                !checkoutValuesPayload.lastName ? (
                                  <span style={{ color: "red" }}>
                                    Last name is required.
                                  </span>
                                ) : null}
                              </Col>
                            </Row>
                          </Form.Group>
                          <FormGroup>
                            <Form.Label className="">Email Address*</Form.Label>
                            <Form.Control
                              required
                              type="email"
                              id="email"
                              name="email"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              disabled={
                                localStorage.getItem("token") ? true : false
                              }
                              className="checkout_input"
                              value={userDetails?.email}
                              isValid={touched.email && !errors.email}
                            ></Form.Control>
                            {emailStatus && loginDisplay && (
                              <Button
                                variant="link"
                                className="user_exist_error"
                                onClick={() => handleCodeChange()}
                              >
                                User already exists, <small>Please Login</small>
                              </Button>
                            )}
                            {errors.email && touched.email ? (
                              <span style={{ color: "red" }}>
                                {errors.email}
                              </span>
                            ) : null}
                          </FormGroup>
                          {!localStorage.getItem("userData") && (
                            <>
                              <FormGroup hidden={emailStatus}>
                                <Form.Label className="">
                                  Confirm Email Address*
                                </Form.Label>
                                <Form.Control
                                  required
                                  type="email"
                                  id="confirmEmail"
                                  name="confirmEmail"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  className="checkout_input"
                                  disabled={emailStatus}
                                  isValid={
                                    touched.confirmEmail && !errors.confirmEmail
                                  }
                                />
                                {errors.confirmEmail && touched.confirmEmail ? (
                                  <span style={{ color: "red" }}>
                                    {errors.confirmEmail}
                                  </span>
                                ) : null}
                              </FormGroup>
                              <FormGroup hidden={emailStatus}>
                                <Form.Label className="">
                                  Account Password*
                                </Form.Label>
                                <Form.Control
                                  required
                                  type="password"
                                  id="password"
                                  name="password"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  disabled={emailStatus}
                                  className="checkout_input"
                                  isValid={touched.password && !errors.password}
                                />
                                {errors.password && touched.password ? (
                                  <span style={{ color: "red" }}>
                                    {errors.password}
                                  </span>
                                ) : null}
                              </FormGroup>
                              <FormGroup hidden={emailStatus}>
                                <Form.Label className="">
                                  Confirm Password*
                                </Form.Label>
                                <Form.Control
                                  required
                                  type="password"
                                  id="confirmPassword"
                                  name="confirmPassword"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  disabled={emailStatus}
                                  className="checkout_input"
                                  isValid={
                                    touched.confirmPassword &&
                                    !errors.confirmPassword
                                  }
                                />
                                {errors.confirmPassword &&
                                touched.confirmPassword ? (
                                  <span style={{ color: "red" }}>
                                    {errors.confirmPassword}
                                  </span>
                                ) : null}
                              </FormGroup>
                            </>
                          )}

                          <Form.Group className="">
                            <Row>
                              <Col>
                                <Form.Label className=" d-block">
                                  Phone Number*
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  id="mobile"
                                  name="mobile"
                                  maxLength={10}
                                  value={
                                    formattedNumber
                                      ? formattedNumber
                                      : checkoutValuesPayload?.mobile
                                  }
                                  disabled={emailStatus}
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  className="checkout_input"
                                  isValid={touched?.mobile && !errors?.mobile}
                                />
                                {console.log(
                                  "$$$$$$aaa",
                                  errors.mobile,
                                  touched.mobile,
                                  !checkoutValuesPayload?.mobile
                                )}
                                {errors.mobile &&
                                touched.mobile &&
                                !checkoutValuesPayload?.mobile ? (
                                  <span style={{ color: "red" }}>
                                    Phone Number is required
                                  </span>
                                ) : null}
                              </Col>
                              <Col>
                                <Form.Label className="">
                                  Company Name (Optional)
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  id="companyName"
                                  name="companyName"
                                  value={checkoutValuesPayload?.companyName}
                                  disabled={emailStatus}
                                  onChange={handleChange}
                                  className="checkout_input"
                                />
                              </Col>
                            </Row>
                          </Form.Group>
                          <Form.Group>
                            <Row>
                              <Col>
                                <Form.Label className=" d-block">
                                  Street Address*
                                </Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  id="streetAddress"
                                  name="streetAddress"
                                  value={checkoutValuesPayload?.streetAddress}
                                  onBlur={handleBlur}
                                  disabled={emailStatus}
                                  onChange={handleChange}
                                  className="checkout_input"
                                  isValid={
                                    touched.streetAddress &&
                                    !errors.streetAddress
                                  }
                                />
                                {errors.streetAddress &&
                                touched.streetAddress &&
                                !checkoutValuesPayload.streetAddress ? (
                                  <span style={{ color: "red" }}>
                                    Address is required
                                  </span>
                                ) : null}
                              </Col>
                              <Col>
                                <Form.Label className="">
                                  Town / City *
                                </Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  id="city"
                                  name="city"
                                  value={checkoutValuesPayload?.city}
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  disabled={emailStatus}
                                  className="checkout_input"
                                  isValid={touched.city && !errors.city}
                                />
                                {errors.city &&
                                touched.city &&
                                !checkoutValuesPayload.city ? (
                                  <span style={{ color: "red" }}>
                                    City is required
                                  </span>
                                ) : null}
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group as={Col} controlId="formGridState">
                            <Row>
                              <Col>
                                <Form.Label className="">
                                  State / Province *
                                </Form.Label>
                                <Form.Control
                                  required
                                  type="text"
                                  id="state"
                                  name="state"
                                  value={checkoutValuesPayload?.state}
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  disabled={emailStatus}
                                  className="checkout_input"
                                  isValid={touched.state && !errors.state}
                                />
                                {errors.state &&
                                touched.state &&
                                !checkoutValuesPayload.state ? (
                                  <span style={{ color: "red" }}>
                                    State is required
                                  </span>
                                ) : null}
                              </Col>
                              <Col>
                                <Form.Label>Country / Region *</Form.Label>
                                <Form.Select
                                  required
                                  id="country"
                                  name="country"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  disabled={emailStatus}
                                  isValid={touched.country && !errors.country}
                                >
                                  <option value="">
                                    Select Country/Region
                                  </option>
                                  <option value="Afghanistan">
                                    Afghanistan
                                  </option>
                                  <option value="Åland Islands">
                                    Åland Islands
                                  </option>
                                  <option value="Albania">Albania</option>
                                  <option value="Algeria">Algeria</option>
                                  <option value="American Samoa">
                                    American Samoa
                                  </option>
                                  <option value="Andorra">Andorra</option>
                                  <option value="Angola">Angola</option>
                                  <option value="Anguilla">Anguilla</option>
                                  <option value="Antarctica">Antarctica</option>
                                  <option value="Antigua and Barbuda">
                                    Antigua and Barbuda
                                  </option>
                                  <option value="Argentina">Argentina</option>
                                  <option value="Armenia">Armenia</option>
                                  <option value="Aruba">Aruba</option>
                                  <option value="Australia">Australia</option>
                                  <option value="Austria">Austria</option>
                                  <option value="Azerbaijan">Azerbaijan</option>
                                  <option value="Bahamas (the)">
                                    Bahamas (the)
                                  </option>
                                  <option value="Bahrain">Bahrain</option>
                                  <option value="Bangladesh">Bangladesh</option>
                                  <option value="Barbados">Barbados</option>
                                  <option value="Belarus">Belarus</option>
                                  <option value="Belgium">Belgium</option>
                                  <option value="Belize">Belize</option>
                                  <option value="Benin">Benin</option>
                                  <option value="Bermuda">Bermuda</option>
                                  <option value="Bhutan">Bhutan</option>
                                  <option value="Bolivia (Plurinational State of)">
                                    Bolivia (Plurinational State of)
                                  </option>
                                  <option value="Bonaire, Sint Eustatius and Saba">
                                    Bonaire, Sint Eustatius and Saba
                                  </option>
                                  <option value="Bosnia and Herzegovina">
                                    Bosnia and Herzegovina
                                  </option>
                                  <option value="Botswana">Botswana</option>
                                  <option value="Bouvet Island">
                                    Bouvet Island
                                  </option>
                                  <option value="Brazil">Brazil</option>
                                  <option value="British Indian Ocean Territory (the)">
                                    British Indian Ocean Territory (the)
                                  </option>
                                  <option value="Brunei Darussalam">
                                    Brunei Darussalam
                                  </option>
                                  <option value="Bulgaria">Bulgaria</option>
                                  <option value="Burkina Faso">
                                    Burkina Faso
                                  </option>
                                  <option value="Burundi">Burundi</option>
                                  <option value="Cabo Verde">Cabo Verde</option>
                                  <option value="Cambodia">Cambodia</option>
                                  <option value="Cameroon">Cameroon</option>
                                  <option value="Canada">Canada</option>
                                  <option value="Cayman Islands (the)">
                                    Cayman Islands (the)
                                  </option>
                                  <option value="Central African Republic (the)">
                                    Central African Republic (the)
                                  </option>
                                  <option value="Chad">Chad</option>
                                  <option value="Chile">Chile</option>
                                  <option value="China">China</option>
                                  <option value="Christmas Island">
                                    Christmas Island
                                  </option>
                                  <option value="Cocos (Keeling) Islands (the)">
                                    Cocos (Keeling) Islands (the)
                                  </option>
                                  <option value="Colombia">Colombia</option>
                                  <option value="Comoros (the)">
                                    Comoros (the)
                                  </option>
                                  <option value="Congo (the Democratic Republic of the)">
                                    Congo (the Democratic Republic of the)
                                  </option>
                                  <option value="Congo (the)">
                                    Congo (the)
                                  </option>
                                  <option value="Cook Islands (the)">
                                    Cook Islands (the)
                                  </option>
                                  <option value="Costa Rica">Costa Rica</option>
                                  <option value="Croatia">Croatia</option>
                                  <option value="Cuba">Cuba</option>
                                  <option value="Curaçao">Curaçao</option>
                                  <option value="Cyprus">Cyprus</option>
                                  <option value="Czechia">Czechia</option>
                                  <option value="Côte d'Ivoire">
                                    Côte d'Ivoire
                                  </option>
                                  <option value="Denmark">Denmark</option>
                                  <option value="Djibouti">Djibouti</option>
                                  <option value="Dominica">Dominica</option>
                                  <option value="Dominican Republic (the)">
                                    Dominican Republic (the)
                                  </option>
                                  <option value="Ecuador">Ecuador</option>
                                  <option value="Egypt">Egypt</option>
                                  <option value="El Salvador">
                                    El Salvador
                                  </option>
                                  <option value="Equatorial Guinea">
                                    Equatorial Guinea
                                  </option>
                                  <option value="Eritrea">Eritrea</option>
                                  <option value="Estonia">Estonia</option>
                                  <option value="Eswatini">Eswatini</option>
                                  <option value="Ethiopia">Ethiopia</option>
                                  <option value="Falkland Islands (the) [Malvinas]">
                                    Falkland Islands (the) [Malvinas]
                                  </option>
                                  <option value="Faroe Islands (the)">
                                    Faroe Islands (the)
                                  </option>
                                  <option value="Fiji">Fiji</option>
                                  <option value="Finland">Finland</option>
                                  <option value="France">France</option>
                                  <option value="French Guiana">
                                    French Guiana
                                  </option>
                                  <option value="French Polynesia">
                                    French Polynesia
                                  </option>
                                  <option value="French Southern Territories (the)">
                                    French Southern Territories (the)
                                  </option>
                                  <option value="Gabon">Gabon</option>
                                  <option value="Gambia (the)">
                                    Gambia (the)
                                  </option>
                                  <option value="Georgia">Georgia</option>
                                  <option value="Germany">Germany</option>
                                  <option value="Ghana">Ghana</option>
                                  <option value="Gibraltar">Gibraltar</option>
                                  <option value="Greece">Greece</option>
                                  <option value="Greenland">Greenland</option>
                                  <option value="Grenada">Grenada</option>
                                  <option value="Guadeloupe">Guadeloupe</option>
                                  <option value="Guam">Guam</option>
                                  <option value="Guatemala">Guatemala</option>
                                  <option value="Guernsey">Guernsey</option>
                                  <option value="Guinea">Guinea</option>
                                  <option value="Guinea-Bissau">
                                    Guinea-Bissau
                                  </option>
                                  <option value="Guyana">Guyana</option>
                                  <option value="Haiti">Haiti</option>
                                  <option value="Heard Island and McDonald Islands">
                                    Heard Island and McDonald Islands
                                  </option>
                                  <option value="Holy See (the)">
                                    Holy See (the)
                                  </option>
                                  <option value="Honduras">Honduras</option>
                                  <option value="Hong Kong">Hong Kong</option>
                                  <option value="Hungary">Hungary</option>
                                  <option value="Iceland">Iceland</option>
                                  <option value="India">India</option>
                                  <option value="Indonesia">Indonesia</option>
                                  <option value="Iran (Islamic Republic of)">
                                    Iran (Islamic Republic of)
                                  </option>
                                  <option value="Iraq">Iraq</option>
                                  <option value="Ireland">Ireland</option>
                                  <option value="Isle of Man">
                                    Isle of Man
                                  </option>
                                  <option value="Israel">Israel</option>
                                  <option value="Italy">Italy</option>
                                  <option value="Jamaica">Jamaica</option>
                                  <option value="Japan">Japan</option>
                                  <option value="Jersey">Jersey</option>
                                  <option value="Jordan">Jordan</option>
                                  <option value="Kazakhstan">Kazakhstan</option>
                                  <option value="Kenya">Kenya</option>
                                  <option value="Kiribati">Kiribati</option>
                                  <option value="Korea (the Democratic People's Republic of)">
                                    Korea (the Democratic People's Republic of)
                                  </option>
                                  <option value="Korea (the Republic of)">
                                    Korea (the Republic of)
                                  </option>
                                  <option value="Kuwait">Kuwait</option>
                                  <option value="Kyrgyzstan">Kyrgyzstan</option>
                                  <option value="Lao People's Democratic Republic (the)">
                                    Lao People's Democratic Republic (the)
                                  </option>
                                  <option value="Latvia">Latvia</option>
                                  <option value="Lebanon">Lebanon</option>
                                  <option value="Lesotho">Lesotho</option>
                                  <option value="Liberia">Liberia</option>
                                  <option value="Libya">Libya</option>
                                  <option value="Liechtenstein">
                                    Liechtenstein
                                  </option>
                                  <option value="Lithuania">Lithuania</option>
                                  <option value="Luxembourg">Luxembourg</option>
                                  <option value="Macao">Macao</option>
                                  <option value="Madagascar">Madagascar</option>
                                  <option value="Malawi">Malawi</option>
                                  <option value="Malaysia">Malaysia</option>
                                  <option value="Maldives">Maldives</option>
                                  <option value="Mali">Mali</option>
                                  <option value="Malta">Malta</option>
                                  <option value="Marshall Islands (the)">
                                    Marshall Islands (the)
                                  </option>
                                  <option value="Martinique">Martinique</option>
                                  <option value="Mauritania">Mauritania</option>
                                  <option value="Mauritius">Mauritius</option>
                                  <option value="Mayotte">Mayotte</option>
                                  <option value="Mexico">Mexico</option>
                                  <option value="Micronesia (Federated States of)">
                                    Micronesia (Federated States of)
                                  </option>
                                  <option value="Moldova (the Republic of)">
                                    Moldova (the Republic of)
                                  </option>
                                  <option value="Monaco">Monaco</option>
                                  <option value="Mongolia">Mongolia</option>
                                  <option value="Montenegro">Montenegro</option>
                                  <option value="Montserrat">Montserrat</option>
                                  <option value="Morocco">Morocco</option>
                                  <option value="Mozambique">Mozambique</option>
                                  <option value="Myanmar">Myanmar</option>
                                  <option value="Namibia">Namibia</option>
                                  <option value="Nauru">Nauru</option>
                                  <option value="Nepal">Nepal</option>
                                  <option value="Netherlands (the)">
                                    Netherlands (the)
                                  </option>
                                  <option value="New Caledonia">
                                    New Caledonia
                                  </option>
                                  <option value="New Zealand">
                                    New Zealand
                                  </option>
                                  <option value="Nicaragua">Nicaragua</option>
                                  <option value="Niger (the)">
                                    Niger (the)
                                  </option>
                                  <option value="Nigeria">Nigeria</option>
                                  <option value="Niue">Niue</option>
                                  <option value="Norfolk Island">
                                    Norfolk Island
                                  </option>
                                  <option value="Northern Mariana Islands (the)">
                                    Northern Mariana Islands (the)
                                  </option>
                                  <option value="Norway">Norway</option>
                                  <option value="Oman">Oman</option>
                                  <option value="Pakistan">Pakistan</option>
                                  <option value="Palau">Palau</option>
                                  <option value="Palestine, State of">
                                    Palestine, State of
                                  </option>
                                  <option value="Panama">Panama</option>
                                  <option value="Papua New Guinea">
                                    Papua New Guinea
                                  </option>
                                  <option value="Paraguay">Paraguay</option>
                                  <option value="Peru">Peru</option>
                                  <option value="Philippines (the)">
                                    Philippines (the)
                                  </option>
                                  <option value="Pitcairn">Pitcairn</option>
                                  <option value="Poland">Poland</option>
                                  <option value="Portugal">Portugal</option>
                                  <option value="Puerto Rico">
                                    Puerto Rico
                                  </option>
                                  <option value="Qatar">Qatar</option>
                                  <option value="Republic of North Macedonia">
                                    Republic of North Macedonia
                                  </option>
                                  <option value="Romania">Romania</option>
                                  <option value="Russian Federation (the)">
                                    Russian Federation (the)
                                  </option>
                                  <option value="Rwanda">Rwanda</option>
                                  <option value="Réunion">Réunion</option>
                                  <option value="Saint Barthélemy">
                                    Saint Barthélemy
                                  </option>
                                  <option value="Saint Helena, Ascension and Tristan da Cunha">
                                    Saint Helena, Ascension and Tristan da Cunha
                                  </option>
                                  <option value="Saint Kitts and Nevis">
                                    Saint Kitts and Nevis
                                  </option>
                                  <option value="Saint Lucia">
                                    Saint Lucia
                                  </option>
                                  <option value="Saint Martin (French part)">
                                    Saint Martin (French part)
                                  </option>
                                  <option value="Saint Pierre and Miquelon">
                                    Saint Pierre and Miquelon
                                  </option>
                                  <option value="Saint Vincent and the Grenadines">
                                    Saint Vincent and the Grenadines
                                  </option>
                                  <option value="Samoa">Samoa</option>
                                  <option value="San Marino">San Marino</option>
                                  <option value="Sao Tome and Principe">
                                    Sao Tome and Principe
                                  </option>
                                  <option value="Saudi Arabia">
                                    Saudi Arabia
                                  </option>
                                  <option value="Senegal">Senegal</option>
                                  <option value="Serbia">Serbia</option>
                                  <option value="Seychelles">Seychelles</option>
                                  <option value="Sierra Leone">
                                    Sierra Leone
                                  </option>
                                  <option value="Singapore">Singapore</option>
                                  <option value="Sint Maarten (Dutch part)">
                                    Sint Maarten (Dutch part)
                                  </option>
                                  <option value="Slovakia">Slovakia</option>
                                  <option value="Slovenia">Slovenia</option>
                                  <option value="Solomon Islands">
                                    Solomon Islands
                                  </option>
                                  <option value="Somalia">Somalia</option>
                                  <option value="South Africa">
                                    South Africa
                                  </option>
                                  <option value="South Georgia and the South Sandwich Islands">
                                    South Georgia and the South Sandwich Islands
                                  </option>
                                  <option value="South Sudan">
                                    South Sudan
                                  </option>
                                  <option value="Spain">Spain</option>
                                  <option value="Sri Lanka">Sri Lanka</option>
                                  <option value="Sudan (the)">
                                    Sudan (the)
                                  </option>
                                  <option value="Suriname">Suriname</option>
                                  <option value="Svalbard and Jan Mayen">
                                    Svalbard and Jan Mayen
                                  </option>
                                  <option value="Sweden">Sweden</option>
                                  <option value="Switzerland">
                                    Switzerland
                                  </option>
                                  <option value="Syrian Arab Republic">
                                    Syrian Arab Republic
                                  </option>
                                  <option value="Taiwan (Province of China)">
                                    Taiwan (Province of China)
                                  </option>
                                  <option value="Tajikistan">Tajikistan</option>
                                  <option value="Tanzania, United Republic of">
                                    Tanzania, United Republic of
                                  </option>
                                  <option value="Thailand">Thailand</option>
                                  <option value="Timor-Leste">
                                    Timor-Leste
                                  </option>
                                  <option value="Togo">Togo</option>
                                  <option value="Tokelau">Tokelau</option>
                                  <option value="Tonga">Tonga</option>
                                  <option value="Trinidad and Tobago">
                                    Trinidad and Tobago
                                  </option>
                                  <option value="Tunisia">Tunisia</option>
                                  <option value="Turkey">Turkey</option>
                                  <option value="Turkmenistan">
                                    Turkmenistan
                                  </option>
                                  <option value="Turks and Caicos Islands (the)">
                                    Turks and Caicos Islands (the)
                                  </option>
                                  <option value="Tuvalu">Tuvalu</option>
                                  <option value="Uganda">Uganda</option>
                                  <option value="Ukraine">Ukraine</option>
                                  <option value="United Arab Emirates (the)">
                                    United Arab Emirates (the)
                                  </option>
                                  <option
                                    value="United Kingdom of Great Britain and Northern
                                Ireland (the)"
                                  >
                                    United Kingdom of Great Britain and Northern
                                    Ireland (the)
                                  </option>
                                  <option value="United States Minor Outlying Islands (the)">
                                    United States Minor Outlying Islands (the)
                                  </option>
                                  <option value="United States of America (the)">
                                    United States of America (the)
                                  </option>
                                  <option value="Uruguay">Uruguay</option>
                                  <option value="Uzbekistan">Uzbekistan</option>
                                  <option value="Vanuatu">Vanuatu</option>
                                  <option value="Venezuela (Bolivarian Republic of)">
                                    Venezuela (Bolivarian Republic of)
                                  </option>
                                  <option value="Viet Nam">Viet Nam</option>
                                  <option value="Virgin Islands (British)">
                                    Virgin Islands (British)
                                  </option>
                                  <option value="Virgin Islands (U.S.)">
                                    Virgin Islands (U.S.)
                                  </option>
                                  <option value="Wallis and Futuna">
                                    Wallis and Futuna
                                  </option>
                                  <option value="Western Sahara">
                                    Western Sahara
                                  </option>
                                  <option value="Yemen">Yemen</option>
                                  <option value="Zambia">Zambia</option>
                                  298751362
                                  <option value="Zimbabwe">Zimbabwe</option>
                                </Form.Select>
                                {errors.country && touched.country ? (
                                  <span style={{ color: "red" }}>
                                    Country is required
                                  </span>
                                ) : null}
                              </Col>
                            </Row>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>Order Notes (Optional)</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              placeholder="Leave us a note regarding your order"
                              className="mb-2"
                              id="orderNotes"
                              name="orderNotes"
                              disabled={emailStatus}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Form>
                      </div>
                      <Payment
                        payableAmount={payableAmount}
                        price={price}
                        checkoutValuesPayload={checkoutValuesPayload}
                        couponCode={couponCode}
                        userCart={userCart}
                        isValid={isValid}
                        errors={errors}
                        setUserDetails={setUserDetails}
                      />
                    </>
                  )}
                </Formik>
              </Col>
              <Col
                className="checkout_info_wrapper d-flex flex-column justify-content-between"
                xxl="5"
                lg="5"
              >
                <div className="box_shadow ssl_checkout checkout_info_tab mb-5">
                  <h3>
                    Your Order is Secured By Our <br /> 256-bit SSL Encrypted
                    Checkout
                  </h3>
                  <p className="">
                    Your personal information is safe with us. We use a secure
                    256-bit SSL encryption, which is the American standard when
                    it comes to protecting customers private information while
                    making purchases online. This is the same level of
                    encryption that the U.S Government uses to protect data.{" "}
                  </p>
                  <img src={sslSecurityImage} alt="SSl Secrity" />
                </div>
                <div className="box_shadow  checkout_info_tab mb-5">
                  <h3>Our Genuine Software Guarantee</h3>
                  <p className="">
                    We want our loyal customers to shop with confidence which is
                    why we guarantee that every purchase made with us includes
                    published versions of Microsoft software which are properly
                    licensed, and supported by Microsoft.
                  </p>
                  <h3 className="mt-4">Our Customer Satisfaction Guarantee</h3>
                  <p>
                    We strive for excellence and quality in everything we do.
                    You may rest assured that your purchase comes with our 100%
                    customer satisfaction guarantee accompanied by our 90-day
                    hassle-free refund policy.{" "}
                  </p>
                </div>
                <div className="box_shadow  checkout_info_tab mb-5">
                  <h3>24/7 Tech Support</h3>
                  <p className="">
                    Our team of highly trained professionals work around the
                    clock to make software installations a breeze by helping to
                    identify problems and provide immediate solutions that may
                    arise during and after the installation of software.
                  </p>
                  <h3 className="mt-4">
                    Instant Delivery Upon Order Completion
                  </h3>
                  <p className="">
                    Your order is processed immediately after the checkout
                    process is complete. You will be transferred to your account
                    area where you will have instant access to your download
                    media and license key.
                  </p>
                </div>
                <div className="box_shadow  checkout_info_tab mb-2">
                  <h3>How To Install Your Software</h3>
                  <p className="">
                    You will be transferred to your account area following the
                    checkout process where you will find your download media,
                    license key, and installation guide to download your
                    software. Get in touch with our support team for more info.
                  </p>
                  <h3 className="mt-4">Have Questions?</h3>
                  <p>
                    We'd love to hear from you! Whether you have questions about
                    your order, the installation of your purchased software, or
                    anything else, our team takes pride knowing that they're
                    here to help guide you along the way.{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      {Status && (
        <LoginModal
          show={Status}
          setStatus={setStatus}
          backdrop="static"
          keyboard={false}
          setEmailStatus={setEmailStatus}
          setLoginDisplay={setLoginDisplay}
          setLogedIn={setLogedIn}
          setUserDetails={setUserDetails}
        />
      )}
    </>
  );
};

export default Checkout;
